if (!customElements.get("deferred-video")) {
  class DeferredVideo extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.poster = this.closest("section").querySelector(
        `#Deferred-Poster-Modal-${this.dataset.mediaId}, .deferred-media__poster`,
      );
      if (!this.poster) return;

      this.poster.addEventListener("click", () => this.loadContent(true));

      if (this.dataset.autoplay === "true") {
        this.setupAutoplayObserver();
      }
    }

    setupAutoplayObserver() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadContent(true);
              observer.unobserve(this);
            }
          });
        },
        { threshold: 0.2 },
      );
      observer.observe(this);
    }

    loadContent(shouldPlay = false) {
      if (this.hasAttribute("loaded")) return;
      this.setAttribute("loaded", true);

      if (this.poster) {
        this.poster.style.display = "none";
      }

      this.setVideoElement(shouldPlay);
    }

    setVideoElement(shouldPlay = false) {
      const template = this.querySelector("template");
      if (!template) return;

      this.content = template.content.firstElementChild.cloneNode(true);
      const videoElementClass =
        window.innerWidth < 768 && this.content.querySelector(".js-mobile-video")
          ? ".js-mobile-video"
          : ".js-desktop-video";

      this.pauseAllMedia();
      if (this.videoElement) this.videoElement.remove();

      this.videoElement = this.appendChild(this.content.querySelector(`${videoElementClass}, iframe`));
      this.videoElement.setAttribute("data-media-id", this.dataset.mediaId);

      const btn = document.querySelector(`.js-video-play-block[data-media-id="${this.dataset.mediaId}"]`);
      const isYouTube =
        this.videoElement.tagName === "IFRAME" &&
        (this.videoElement.src.includes("youtube.com") || this.videoElement.src.includes("youtu.be"));

      if (isYouTube) {
        if (!this.videoElement.src.includes("enablejsapi=1")) {
          const separator = this.videoElement.src.includes("?") ? "&" : "?";
          this.videoElement.src += `${separator}enablejsapi=1`;
        }

        this.videoElement.addEventListener("load", () => {
          setTimeout(() => {
            if (window.enableYouTubeInfoUpdates) {
              window.enableYouTubeInfoUpdates(this.videoElement);
            }

            if (shouldPlay) {
              this.playVideo(btn);
            }
          }, 300);
        });
      } else if (shouldPlay) {
        setTimeout(() => {
          this.playVideo(btn);
        }, 150);
      }
    }

    playVideo(btn) {
      if (this.videoElement.tagName === "VIDEO") {
        this.videoElement.play().catch((e) => console.error("Autoplay failed:", e));
      } else if (this.videoElement.src.includes("youtube")) {
        this.videoElement.contentWindow.postMessage(
          JSON.stringify({
            event: "command",
            func: "playVideo",
            args: "",
          }),
          "*",
        );
      } else if (this.videoElement.src.includes("vimeo")) {
        this.videoElement.contentWindow.postMessage('{"method":"play"}', "*");
      }

      if (btn && window.updateButtonAppearance) {
        btn.dataset.state = "playing";
        window.updateButtonAppearance(btn, "playing");
      }
    }

    pauseAllMedia() {
      document.querySelectorAll('.js-youtube, iframe[src*="youtube.com"]').forEach((video) => {
        video.contentWindow.postMessage(
          JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: "",
          }),
          "*",
        );
      });
      document.querySelectorAll('.js-vimeo, iframe[src*="vimeo.com"]').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      document.querySelectorAll("video").forEach((video) => video.pause());
      document.querySelectorAll("product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }
  }

  customElements.define("deferred-video", DeferredVideo);
}
